var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import { configureAnchors } from 'react-scrollable-anchor';
import * as Raven from 'raven-js';
import { feathersAuthentication } from './feathers';
import setSocketListeners from './feathers/setSocketListeners';
import message from 'antd/lib/message';
import 'antd/lib/message/style/index.css';
import Routes from './routes';
import PageLoading from './pages/PageLoading';
import './imports/styles/extend.message.scss';
var App = (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isCheckingLogin: true,
        };
        _this.handleNewLogin = _this.handleNewLogin.bind(_this);
        _this.handleCurrentToken = _this.handleCurrentToken.bind(_this);
        _this.handleDeleteToken = _this.handleDeleteToken.bind(_this);
        _this.handleSetToken = _this.handleSetToken.bind(_this);
        return _this;
    }
    App.prototype.componentWillMount = function () {
        var _this = this;
        feathersClient.passport.getJWT()
            .then(function (jwt) {
            if (!jwt) {
                throw new Error();
            }
            return _this.handleCurrentToken();
        })
            .then(function () {
            _this.setState({ isCheckingLogin: false });
        })
            .catch(function () {
            _this.handleNewLogin();
            _this.setState({ isCheckingLogin: false });
        });
    };
    App.prototype.componentDidMount = function () {
        var _this = this;
        message.config({
            top: 8,
            getContainer: function () { return document.getElementById('root') || document.body; },
        });
        configureAnchors({
            offset: -72,
            scrollDuration: 150,
        });
        window.addEventListener('storage', function (e) {
            if (e.key !== 'crimp-jwt') {
                return;
            }
            if (e.newValue) {
                _this.handleSetToken(e.newValue);
            }
            if (e.newValue === null ||
                e.newValue === undefined) {
                _this.handleDeleteToken();
            }
        });
        feathersClient.on('authenticated', function (authRes) {
            var user = authRes.data;
            Raven.setUserContext({ userId: user.id });
        });
        feathersClient.on('logout', function () {
            _this.handleNewLogin();
            Raven.setUserContext();
        });
        setSocketListeners();
        this.timer = setTimeout(function () {
            if (!_this.props.isAuthenticated) {
                _this.setState({ isCheckingLogin: true });
                _this.handleNewLogin()
                    .then(function () {
                    _this.setState({ isCheckingLogin: false });
                })
                    .catch(function () {
                    message.error(React.createElement("span", { style: { cursor: 'pointer' }, onClick: function () { return window.location.reload(true); } },
                        "Something went wrong...",
                        React.createElement("br", null),
                        "Tap here to refresh"), 0);
                });
            }
        }, 7500);
    };
    App.prototype.componentWillUnmount = function () {
        clearTimeout(this.timer);
    };
    App.prototype.handleNewLogin = function () {
        return this.props.dispatch(feathersAuthentication.authenticate({
            strategy: 'local',
            email: 'client-web@crimp.rocks',
            password: 'clientwebcrimprocks',
        }));
    };
    App.prototype.handleCurrentToken = function () {
        return this.props.dispatch(feathersAuthentication.authenticate());
    };
    App.prototype.handleDeleteToken = function () {
        return this.props.dispatch(feathersAuthentication.logout());
    };
    App.prototype.handleSetToken = function (jwtToken) {
        if (this.props.isAuthenticated) {
            return;
        }
        return this.handleCurrentToken();
    };
    App.prototype.render = function () {
        if (this.state.isCheckingLogin) {
            return React.createElement(PageLoading, { loadMessage: 'Putting up the wall...' });
        }
        if (!this.props.isAuthenticated) {
            return React.createElement(PageLoading, { loadMessage: 'Finding the routesetters...' });
        }
        return React.createElement(Routes, null);
    };
    return App;
}(React.Component));
var mapStateToProps = function (state) { return ({
    workspaceMain: state.workspaceMain,
    isAuthenticated: state.auth.isSignedIn,
}); };
export default connect(mapStateToProps)(App);



//////////////////
// WEBPACK FOOTER
// ./src/app.tsx
// module id = 431
// module chunks = 0